export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  about: "nav-link-about",
  why: "nav-link-why",
  values: "nav-link-values",
  locations: "nav-link-locations",
  activities: "nav-link-activities",
  faq: "nav-link-faq",
  contact: "nav-link-contact",
  leadership: "nav-link-leadership",
  join: "nav-cta-join",
  langSwitch: (code) => `lang-switch-${code}`,
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  joinBtn: "hero-cta-join",
  contactBtn: "hero-cta-contact",
};

export const LOCATION = {
  card: (key) => `location-card-${key}`,
  visit: (key) => `location-visit-${key}`,
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  location: "contact-input-location",
  message: "contact-input-message",
  submit: "contact-submit",
};

export const FOOTER = {
  instagram: "footer-link-instagram",
  tiktok: "footer-link-tiktok",
  youtube: "footer-link-youtube",
};

export const LEADERSHIP = {
  section: "leadership-section",
  card: (key) => `leadership-card-${key}`,
};
